<div class="row no-gutters mobile-width">
  <!-- navigation -->
  <aside class="col-12 col-md-3 navigation-background">
    <div class="navigation-wrapper">
    <ng-container *ngFor="let item of menuData; index as i">
      <div class="nav-block" *ngIf="item.visible" [attr.data-index]="i" [class.active]="sectionBlock === item.name">
        <a [routerLink]="" (click)="submitBlock(item.path)">
          <div class="active-block"></div>
          <div class="validation-indicator" [ngClass]="{'valid': item.valid, 'uhoh': item.valid === false}">
            <span class="icon" *ngIf="item.valid != null && item.valid === false">!</span>
            <i class="fas fa-check" *ngIf="item.valid != null && item.valid"></i>
          </div>
          <div [innerHtml]="item.label || 'Confirmation'" class="block-name"></div>
        </a>
      </div>
    </ng-container>
  </div>
</aside>
<!-- /navigation -->

<!-- main div container -->
<div class="col col-12 col-md-9 col-main" [@fadeAnimation]="true">
  <h1 class="section-title" [innerHtml]="sectionData.blockHeading"></h1>
  
  <form [formGroup]="applyForm" novalidate>
  
    <!-- fields wrapper -->
    <div class="fields-wrapper">
      <!-- <div class="overlay" *ngIf="!isEditable && !toggleOpenFields"></div> -->
      <div class="allFieldsAsterisk">
        All fields marked with an <span class="asterisk">*</span> are required.
      </div>
  
      <!-- Question loop -->
      <ng-container *ngFor="let question of questions">
        <ng-container
          *ngIf="
            !question.MultipleResponseChild &&
            question.ParentQuestionName !== 'IULPremPaymentAllocation' &&
            question.ParentQuestionName !== 'IULFixedAcctAlloc' &&
            question.ParentQuestionName !== 'VULFundAggressiveOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundGrowthOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundIncomeOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundGrowthIncomeOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundIndexedOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundLifestyleOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundManagedVolatilityOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundETFOptionsCompound' &&
            question.ParentQuestionName !== 'VULFundConservativeOptionsCompound' &&
            isQuestionVisible(question)
          "
        >
          <div
            class="row"
            [ngClass]="{
              collapse:
                question.QuestionType === 'Compound' &&
                !question.QuestionText &&
                !question.MultipleResponse
            }"
          >
            <div class="col-12">
              <app-question [question]="question" [form]="applyForm" [childQuestions]="getChildQuestions(question)" [isEditable]="isEditable" [enabledQuestions]="enabledQuestions" [toggleOpenFields]="toggleOpenFields">
              </app-question>
            </div>
          </div>
        </ng-container>
      </ng-container>
  
      <!-- total allocation -->
      <percentage-allocation *ngIf="sectionBlock == 'AgentReport'" formControlName="totalAllocation" [form]="applyForm"></percentage-allocation>
      <beneficiary-allocation *ngIf="sectionBlock == 'SECTIONCBeneficiaryInformation'" formControlName="PrimaryTotalAllocation" [form]="applyForm" type="Primary"></beneficiary-allocation>
      <beneficiary-allocation *ngIf="sectionBlock == 'SECTIONCBeneficiaryInformation'" formControlName="SecondaryTotalAllocation" [form]="applyForm" type="Secondary"></beneficiary-allocation>
      <owner-count *ngIf="sectionBlock == 'SECTIONBPolicyOwner'" formControlName="totalOwners" [form]="applyForm" [isEditable]="isEditable"></owner-count>
    </div>
    <!-- /fields wrapper -->
  
    <div class="overall-nav-button-container">
  
      <div class="button-wrapper button-wrapper-next-previous">
        <button class="btn btn-prev float-right" (click)="submitBlock('back')" type="button" *ngIf="showPrevButton">
          <i class="fas fa-angle-left"></i> Prev
        </button>
      </div>
  
      <div class="button-wrapper button-wrapper-next-previous justify-content-end">
        <button class="btn btn-primary btn-next float-right" (click)="submitBlock('fwd')" type="button" [disabled]="disableButton">
          Next <i class="fas fa-angle-right"></i>
        </button>
      </div>
  
    </div>
    
    </form>
  </div>
<!-- main div container -->
</div>